<template>
  <div :class="$style.container">
    <div :class="$style.left">
      <slot></slot>
    </div>
    <div :class="$style.right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "two-column-layout",
  props: {
    ratio: { type: String, required: false, default: "70-30" }, // TODO: Check how we should implement options and values
    spaceBetween: { type: String, required: false, default: "10" } // TODO: Check how we should implement this
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

.container {
  display: flex;
}

.left {
  width: 70%;
  margin-right: rem-calc($spacing-xl);
}

.right {
  width: 30%;
}
</style>
